import { css } from "@styled-system/css";

export const wrapperClass = css({
	position: "relative",
});
